import axios from "axios";

const TIMEOUT_MS = 4000;

/**
 * Tries multiple IP services in sequence so we can store IP even when one fails
 * (e.g. ipify blocked or down). Returns first successful IP or "".
 */
export async function getClientIp(): Promise<string> {
  const sources: Array<() => Promise<string>> = [
    async () => {
      const { data } = await axios.get<{ ip: string }>(
        "https://api.ipify.org/?format=json",
        { timeout: TIMEOUT_MS }
      );
      return data?.ip && typeof data.ip === "string" ? data.ip : "";
    },
    async () => {
      const { data } = await axios.get<{ query?: string }>(
        "https://api.ip-api.com/json/?fields=query",
        { timeout: TIMEOUT_MS }
      );
      return data?.query && typeof data.query === "string" ? data.query : "";
    },
    async () => {
      const { data } = await axios.get<string>("https://icanhazip.com", {
        timeout: TIMEOUT_MS,
        responseType: "text",
      });
      const ip = typeof data === "string" ? data.trim() : "";
      return ip && /^[\d.a-f:]+$/i.test(ip) && ip.length >= 7 ? ip : "";
    },
  ];

  for (const source of sources) {
    try {
      const ip = await source();
      if (ip) return ip;
    } catch {
      // continue to next source
    }
  }
  return "";
}
